import { render, staticRenderFns } from "./SmsFeedbackModal.vue?vue&type=template&id=1b6daa40&scoped=true"
import script from "./SmsFeedbackModal.vue?vue&type=script&lang=js"
export * from "./SmsFeedbackModal.vue?vue&type=script&lang=js"
import style0 from "./SmsFeedbackModal.vue?vue&type=style&index=0&id=1b6daa40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6daa40",
  null
  
)

export default component.exports